// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kZhvn","textarea":"styles_textarea__27rx4"};